export const triggerCustomFunction = [
  {
    name: 'triggerCustomFunction',
    label: 'Trigger Function',
    args: [
      {
        name: 'FunctionName',
        label: 'Function Name',
        type: 'dropdown',
        optionsType: 'getCustomFunctionFromApi',
        options: [],
        value: '',
      },
      {
        name: 'collectionRequest',
        label: 'Select Request Type (Optional)',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: '',
      },
      // ✅ NEW: same as navigationActionData
      {
        name: 'collection',
        label: 'Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'referenceField',
        label: 'Reference Field',
        type: 'dropdown',
        optionsType: 'fieldApi',
        options: [],
        value: '',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
    ],
  },
];
